import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import Job from './pages/Job';
import Machines from './pages/Machines';
import Deliveries from './pages/Deliveries';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Calendar from './pages/Calendar';
import Layout from './components/Layout';
import Parts from './pages/Parts';
import Part from './pages/Part';
import Customers from './pages/Customers';
import Financials from './pages/Financials';
import AccessDenied from './pages/AccessDenied';
import Production from './pages/Production';
import CNCQuote from './pages/CNCQuote';
import Kanban from './pages/Kanban';
import KanbanJob from './pages/KanbanJob';
import Invoices from './pages/Invoices';
import About from './pages/Website/About';
import Contact from './pages/Website/Contact';
import ManualQuote from './pages/ManualQuote';
import GeneralQuote from './pages/GeneralQuotesPage';
import Quote from './pages/Quote';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup1213287" element={<SignUp />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:po_number" element={<Job />} /> {/* Updated route */}
            {/* <Route path="/inventory" element={<Inventory />} /> */}
            <Route path="/customers" element={<Customers />} />
            <Route path="/machines" element={<Machines />} />
            <Route path="/deliveries" element={<Deliveries />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/parts" element={<Parts />} />
            <Route path="/financials" element={<Financials />} />
            <Route path="/part/:part_number" element={<Part />} />
            {/* <Route path="*" element={<NotFound />} /> */}
            <Route path="/access-denied" element={<AccessDenied />} /> {/* Add AccessDenied route */}
            <Route path="/production" element={<Production />} />
            <Route path="/cncquote" element={<CNCQuote />} />
            <Route path="/kanban" element={<Kanban />} />
            <Route path="/kanban/:id" element={<KanbanJob />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/manualQuote" element={<ManualQuote />} />
            <Route path="/general-quotes" element={<GeneralQuote />} />
            <Route path="/quote/:id" element={<Quote />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;